/**
 * Set maxWdth for body element to avoid content skipping while scrollbar
 * disappears on pageload
 *
 * @returns {void}
 */
export const updateBodyWidth = () => {
    document.body.style.maxWidth = '100%';
    document.body.style.maxWidth = `${document.body.clientWidth}px`;
};

window.addEventListener('resize', updateBodyWidth);
